import { commandProcessor, Sequence } from "command/command";
import { Move } from "editing/move";
import { UpdateRenderAreaBox } from "editing/render_area";
import { Tool } from "paper";
import store, { appStore } from "store/store";
export class PanTool extends Tool {
    constructor(app) {
        super();
        this.app = app;
        this.components = [];
        this.onMouseDown = (event) => {
            this.app.setIsInteracting(true);
            let allIds = [...store.items().map(i => i.id), ...store.arrows().map(a => a.id)];
            this.components = allIds.map(id => this.app.getObjectComponent(id));
        };
        this.onMouseDrag = (event) => {
            let delta = event.point.subtract(event.downPoint);
            this.components.map(c => c.setPositionDelta(delta));
            this.app.setRenderArea(delta);
        };
        this.onMouseUp = (event) => {
            this.app.setIsInteracting(false);
            let delta = event.point.subtract(event.downPoint);
            if (delta.isZero())
                return;
            const commands = [];
            commands.push(new Move(this.components.map(c => c.id), delta));
            const renderArea = appStore.getState().renderArea;
            if (renderArea) {
                const newArea = Object.assign({}, renderArea);
                newArea.bottom += delta.y;
                newArea.top += delta.y;
                newArea.left += delta.x;
                newArea.right += delta.x;
                commands.push(new UpdateRenderAreaBox(newArea));
            }
            commandProcessor.execute(new Sequence(commands));
            this.components.length = 0;
        };
    }
}
